/** ルート単位の認可ガード（UI/UX設計書 §6 認証・ロール / §8 401・403 の遷移）。
 *  認証状態の復元中はリダイレクトせずスケルトンを出す（未ログイン扱いの誤判定を防ぐ）。 */
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import type { Role } from "../lib/types";
import { Skeleton } from "./ui";

export default function RequireAuth({ roles, children }: { roles?: Role[]; children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container stack" aria-busy="true" aria-label="読み込み中">
        <Skeleton height={32} width="40%" />
        <Skeleton height={240} radius={16} />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/error/403" replace />;
  }
  return <>{children}</>;
}
